<template>
  <span>
    &nbsp;<a @click="copyToClipboard" href="#" title="Copy to clipboard"><i class="fa fa-clipboard"></i></a>
  </span>
</template>

<script>
import primitiveMixin from './primitive-mixin';
import Vue from 'vue';
import VueClipboard from 'vue-clipboard2';
Vue.use(VueClipboard);

export default {
  mixins: [primitiveMixin],
  data() {
    return {
      text: ''
    }
  },
  name: "AmfCopyText",
  methods: {
    copyToClipboard() {
      this.$copyText(this.text).then(() => {
        toastService.success('Copied to clipboard');
      });
    }
  },
  mounted() {
    this.$nextTick(function() {
      this.text = this.$el.previousSibling.innerText;
    })
  }
}
</script>

<style scoped>
  .fa-clipboard {
    cursor: pointer;
  }
</style>



// WEBPACK FOOTER //
// src/framework/primitives/AmfCopyText.vue